export default "__VITE_ASSET__ef4d48b7__"